import { render, staticRenderFns } from "./ForeignInfo.vue?vue&type=template&id=19829efb&scoped=true"
import script from "./ForeignInfo.vue?vue&type=script&lang=js"
export * from "./ForeignInfo.vue?vue&type=script&lang=js"
import style0 from "./ForeignInfo.vue?vue&type=style&index=0&id=19829efb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19829efb",
  null
  
)

export default component.exports